var map = {
	"./en/01/steps/01-01.json": "./src/lib/lessons/en/01/steps/01-01.json",
	"./ko/01/steps/01-01.json": "./src/lib/lessons/ko/01/steps/01-01.json",
	"./ko/01/steps/01-02.json": "./src/lib/lessons/ko/01/steps/01-02.json",
	"./ko/01/steps/01-03.json": "./src/lib/lessons/ko/01/steps/01-03.json",
	"./ko/01/steps/01-04.json": "./src/lib/lessons/ko/01/steps/01-04.json",
	"./ko/01/steps/01-05.json": "./src/lib/lessons/ko/01/steps/01-05.json",
	"./ko/02/steps/02-01.json": "./src/lib/lessons/ko/02/steps/02-01.json",
	"./ko/02/steps/02-02.json": "./src/lib/lessons/ko/02/steps/02-02.json",
	"./ko/02/steps/02-03.json": "./src/lib/lessons/ko/02/steps/02-03.json",
	"./ko/03/steps/03-01.json": "./src/lib/lessons/ko/03/steps/03-01.json",
	"./ko/03/steps/03-02.json": "./src/lib/lessons/ko/03/steps/03-02.json",
	"./ko/03/steps/03-03.json": "./src/lib/lessons/ko/03/steps/03-03.json",
	"./ko/04/steps/04-01.json": "./src/lib/lessons/ko/04/steps/04-01.json",
	"./ko/04/steps/04-02.json": "./src/lib/lessons/ko/04/steps/04-02.json",
	"./ko/05/steps/05-01.json": "./src/lib/lessons/ko/05/steps/05-01.json",
	"./ko/05/steps/05-02.json": "./src/lib/lessons/ko/05/steps/05-02.json",
	"./ko/05/steps/05-03.json": "./src/lib/lessons/ko/05/steps/05-03.json",
	"./ko/05/steps/05-04.json": "./src/lib/lessons/ko/05/steps/05-04.json",
	"./ko/06/steps/06-01.json": "./src/lib/lessons/ko/06/steps/06-01.json",
	"./ko/06/steps/06-02.json": "./src/lib/lessons/ko/06/steps/06-02.json",
	"./ko/06/steps/06-03.json": "./src/lib/lessons/ko/06/steps/06-03.json",
	"./ko/06/steps/06-04.json": "./src/lib/lessons/ko/06/steps/06-04.json",
	"./ko/07/steps/07-01.json": "./src/lib/lessons/ko/07/steps/07-01.json",
	"./ko/07/steps/07-02.json": "./src/lib/lessons/ko/07/steps/07-02.json",
	"./ko/07/steps/07-03.json": "./src/lib/lessons/ko/07/steps/07-03.json",
	"./ko/07/steps/07-04.json": "./src/lib/lessons/ko/07/steps/07-04.json",
	"./ko/08/steps/08-01.json": "./src/lib/lessons/ko/08/steps/08-01.json",
	"./ko/08/steps/08-02.json": "./src/lib/lessons/ko/08/steps/08-02.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/lib/lessons sync recursive steps\\/.*\\.json$";